var exports = {
  "B_": "MessageJumpLink.module__jumpLinkButton___VUNKY0",
  "y_": "MessageJumpLink.module__part___VUNKY0",
  "Kk": "MessageJumpLink.module__icon___VUNKY0",
  "$f": "MessageJumpLink.module__guildIcon___VUNKY0",
  "ds": "MessageJumpLink.module__guildInitials___VUNKY0",
  "yF": "MessageJumpLink.module__divider___VUNKY0",
  "UU": "MessageJumpLink.module__name___VUNKY0",
  "m0": "MessageJumpLink.module__noAccess___VUNKY0",
};

module.exports = exports;
